// Libraries
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { BAR_VERTICAL, BAR_HORIZONTAL, LINE, PIE } from 'common/enums/chartTypes';
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import SingleSelectVerticalBarChart from 'engagementReport/components/singleSelect/SingleSelectVerticalBarChart';
import SingleSelectHorizontalBarChart from 'engagementReport/components/singleSelect/SingleSelectHorizontalBarChart';
import SingleSelectLineChart from 'engagementReport/components/singleSelect/SingleSelectLineChart';
import SingleSelectPieChart from 'engagementReport/components/singleSelect/SingleSelectPieChart';

const renderChart = ({ chartType, data }, width) => {
  switch (chartType) {
    case BAR_HORIZONTAL:
      return <SingleSelectHorizontalBarChart data={data} width={width} />;
    case LINE:
      return <SingleSelectLineChart data={data} />;
    case PIE:
      return <SingleSelectPieChart data={data} />;
    case BAR_VERTICAL:
    default:
      return <SingleSelectVerticalBarChart data={data} />;
  }
};

const SingleSelectReport = ({ question }) => {
  const ref = useRef();
  const { t } = useTranslation();
  const [width, setWidth] = useState();
  const isEmpty = question.data.every((datum) => datum.count === 0);

  useEffect(() => {
    setWidth(ref.current?.getBoundingClientRect().width);
  }, []);

  return (
    <div className="single-select-report" ref={ref}>
      {isEmpty && (
        <div className="basic-report__subtitle">{t('engagement_report.no_responses')}</div>
      )}
      {!isEmpty && renderChart(question, width)}
    </div>
  );
};

SingleSelectReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default SingleSelectReport;
